'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _DateConstants = require('./DateConstants');

var _DateConstants2 = _interopRequireDefault(_DateConstants);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DateTHead = function (_React$Component) {
  (0, _inherits3['default'])(DateTHead, _React$Component);

  function DateTHead() {
    (0, _classCallCheck3['default'])(this, DateTHead);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  DateTHead.prototype.render = function render() {
    var props = this.props;
    var value = props.value;
    var localeData = value.localeData();
    var prefixCls = props.prefixCls;
    var renderDateHeaderCell = props.renderDateHeaderCell;
    var veryShortWeekdays = [];
    var weekDays = [];
    // var firstDayOfWeek = localeData.firstDayOfWeek();
    var firstDayOfWeek = 0;
    var showWeekNumberEl = void 0;
    var now = (0, _moment2['default'])();
    var weekStartsOn = props.weekStartsOn;
    for (var dateColIndex = 0; dateColIndex < _DateConstants2['default'].DATE_COL_COUNT; dateColIndex++) {
      var index = (firstDayOfWeek + dateColIndex) % _DateConstants2['default'].DATE_COL_COUNT;
      now = now.day(index);
      veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
      weekDays[dateColIndex] = localeData.weekdaysShort(now);
    }

    if (props.showWeekNumber) {
      showWeekNumberEl = _react2['default'].createElement(
        'th',
        {
          role: 'columnheader',
          className: prefixCls + '-column-header ' + prefixCls + '-week-number-header'
        },
        _react2['default'].createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          'x'
        )
      );
    }
    
    if (weekStartsOn == 1) {
      weekDays = [weekDays[1], weekDays[2], weekDays[3], weekDays[4], weekDays[5], weekDays[6], weekDays[0]]
    } else if (weekStartsOn == 2) {
      weekDays = [weekDays[2], weekDays[3], weekDays[4], weekDays[5], weekDays[6], weekDays[0], weekDays[1]]
    } else if (weekStartsOn == 3) {
      weekDays = [weekDays[3], weekDays[4], weekDays[5], weekDays[6], weekDays[0], weekDays[1], weekDays[2]]
    } else if (weekStartsOn == 4) {
      weekDays = [weekDays[4], weekDays[5], weekDays[6], weekDays[0], weekDays[1], weekDays[2], weekDays[3]]
    } else if (weekStartsOn == 5) {
      weekDays = [weekDays[5], weekDays[6], weekDays[0], weekDays[1], weekDays[2], weekDays[3], weekDays[4]]
    } else if (weekStartsOn == 6) {
      weekDays = [weekDays[6], weekDays[0], weekDays[1], weekDays[2], weekDays[3], weekDays[4], weekDays[5]]
    }
    var weekDaysEls = weekDays.map(function (day, xindex) {
      if (renderDateHeaderCell) {
        return renderDateHeaderCell(day, xindex, prefixCls)
      }
      return _react2['default'].createElement(
        'th',
        {
          key: xindex,
          role: 'columnheader',
          title: day,
          className: prefixCls + '-column-header'
        },
        _react2['default'].createElement(
          'span',
          { className: prefixCls + '-column-header-inner' },
          // veryShortWeekdays[xindex]
          day
        )
      );
    });
    return _react2['default'].createElement(
      'thead',
      null,
      _react2['default'].createElement(
        'tr',
        { role: 'row' },
        showWeekNumberEl,
        weekDaysEls
      )
    );
  };

  return DateTHead;
}(_react2['default'].Component);

exports['default'] = DateTHead;
module.exports = exports['default'];